import React, { useState } from "react";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Step7 from "./Step7";
import Step8 from "./Step8";
import Step9 from "./Step9";
import Step10 from "./Step10";
import Step11 from "./Step11";
import Step12 from "./Step12";
import Step13 from "./Step13";
import Step14 from "./Step14";
import Step15 from "./Step15";
import Step16 from "./Step16";
import Step17 from "./Step17";
import Step18 from "./Step18";
import Step19 from "./Step19";
import Step20 from "./Step20";
import Step21 from "./Step21";
import Step22 from "./Step22";
import Step23 from "./Step23";
import Step24 from "./Step24";
import Step25 from "./Step25";
import Step26 from "./Step26";
import Step27 from "./Step27";
import Step28 from "./Step28";
import Step29 from "./Step29";
import Step30 from "./Step30";
import Step31 from "./Step31";
import Step32 from "./Step32";
import Step33 from "./Step33";
import Step34 from "./Step34";
import Step35 from "./Step35";
import Step36 from "./Step36";
import Register from "./register";
import Step99 from "./Step99";

const MultiStepForm = () => {
  const [step, setStep] = useState(1);
  const [heating_energy, setheating_energy] = useState("");

  const setStep10optionLocal = (step10) => {
    setStep10option(step10);
  };

  const setStep12OptionLocal = (step12) => {
    setStep12Option(step12);
  };

  const setStep13OptionLocal = (step13) => {
    setStep13Option(step13);
  };

  const [step10option, setStep10option] = useState({
    travaux: false,
    adresse: false,
  });

  const [step12Option, setStep12Option] = useState({
    code: false,
    foyer: false,
  });

  const [step13Option, setStep13Option] = useState({
    personne1: false,
    personne2: false,
    personne3: false,
    personne4: false,
    personne5: false,
    personne6: false,
    personne7: false,
    personne8: false,
    personne9: false,
    personne10: false,
    personne11: false,
    personne12: false,
    personne13: false,
    personne14: false,
    personne15: false,
    personne16: false,
    personne17: false,
    personne18: false,
    personne19: false,
    personne20: false,
    personne21: false,
    personne22: false,
    personne23: false,
    personne24: false,
    personne25: false,

  });

  // Ajoutez des fonctions pour passer à l'étape suivante ou précédente
  const nextStep = () => setStep(step + 1);
  const prevStep = () => {
    if (step === 6 && (heating_energy === 'pompe_chaleur' || heating_energy === 'bois' || heating_energy === 'charbon')) {
      setStep(4);
    } else {
      setStep(step - 1);
    }
  };

  // Renvoie le composant d'étape approprié en fonction de l'étape actuelle
  const renderStep = () => {
    switch (step) {
      case 1:
        return <Step1 nextStep={nextStep} setStep={setStep} />;
      case 2:
        return <Step2 prevStep={prevStep} nextStep={nextStep} setStep={setStep} />;
      case 3:
        return <Step3 nextStep={nextStep} prevStep={prevStep} />;
      case 4:
        return <Step4 nextStep={nextStep} prevStep={prevStep} setheating_energy={setheating_energy}  setStep={setStep} />;
      case 5:
        return <Step5
          prevStep={prevStep}
          nextStep={nextStep}
          heating_energy={heating_energy}
          onSetheating_energy={setheating_energy}
        />;
        case 6:
          return <Step6
            prevStep={prevStep}
            nextStep={nextStep}
            setStep={setStep}

          />;
        case 7:
          return (
            <Step7
              prevStep={prevStep}
              setStep={setStep}
              nextStep={nextStep}
            />
          );

        case 8:
          return <Step8 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
          />;

          case 9:
            return <Step9 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
            />;  

        case 10:
          return <Step10 setStep={setStep} nextStep={nextStep}
         />; 
         
         case 11:
          return <Step11 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;   

         case 12:
          return <Step12 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 13:
          return <Step13 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 14:
          return <Step14 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 15:
          return <Step15 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 16:
          return <Step16 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 17:
          return <Step17 prevStep={prevStep} nextStep={nextStep}
         />;

         case 18:
          return <Step18 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 19:
          return <Step19 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 20:
          return <Step20 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 21:
          return <Step21 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 22:
          return <Step22 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 23:
          return <Step23 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 24:
          return <Step24 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 25:
          return <Step25 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 26:
          return <Step26 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 27:
          return <Step27 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 28:
          return <Step28 prevStep={prevStep} nextStep={nextStep} setStep={setStep}
         />;

         case 29:
          return <Step29 prevStep={prevStep} nextStep={nextStep} setStep={setStep} setStep10optionLocal={setStep10optionLocal}
         />;

         case 30:
          return <Step30 prevStep={prevStep} nextStep={nextStep} step10option={step10option}

         />;

         case 31:
          return <Step31 prevStep={prevStep} nextStep={nextStep} setStep={setStep} setStep12OptionLocal={setStep12OptionLocal}
         />;

         case 32:
          return <Step32 
          prevStep={prevStep} 
          nextStep={nextStep} 
          step12Option={step12Option}  
         />;

         case 33:
          return <Step33 
          prevStep={prevStep} 
          nextStep={nextStep} 
          setStep={setStep}
          step12Option={step12Option}  
          setStep13OptionLocal={setStep13OptionLocal}
          personne1={step13Option.personne1}
          personne2={step13Option.personne2}
          personne3={step13Option.personne3}
          personne4={step13Option.personne4}
          personne5={step13Option.personne5}
          personne6={step13Option.personne6}
          personne7={step13Option.personne7}
          personne8={step13Option.personne8}
          personne9={step13Option.personne9}
          personne10={step13Option.personne10}
          personne11={step13Option.personne11}
          personne12={step13Option.personne12}
          personne13={step13Option.personne13}
          personne14={step13Option.personne14}
          personne15={step13Option.personne15}
          personne16={step13Option.personne16}
          personne17={step13Option.personne17}
          personne18={step13Option.personne18}
          personne19={step13Option.personne19}
          personne20={step13Option.personne20}
          personne21={step13Option.personne21}
          personne22={step13Option.personne22}
          personne23={step13Option.personne23}
          personne24={step13Option.personne24}
          personne25={step13Option.personne25}
         />;

         case 34:
          return <Step34 prevStep={prevStep} nextStep={nextStep} step13Option={step13Option}
         />;

         case 35:
          return <Step35 prevStep={prevStep} nextStep={nextStep}
         />;

         case 36:
          return <Step36 prevStep={prevStep} nextStep={nextStep}
         />;

         case 37: 
          return <Register prevStep={prevStep} nextStep={nextStep}
         />; 

         case 99:
           return (
             <Step99
               prevStep={prevStep}
             />
            );
          default:
            return <Step1 nextStep={nextStep} />;
      }
    };
    return (
      renderStep()
    );
  };
  
  export default MultiStepForm;      
